/* eslint-disable @typescript-eslint/no-empty-object-type */

import { OverrideProps } from '@mui/types';
import { Children, ElementType, PropsWithChildren, ReactNode } from 'react';

import { NULLISH_VALUE } from '~/common/constants';

export interface WrapWithOwnProps extends PropsWithChildren {
  fallback?: ReactNode;
}

export interface WrapWithTypeMap<P = {}, D extends ElementType = 'div'> {
  props: P & WrapWithOwnProps;
  defaultComponent: D;
}

export type WrapWithProps<D extends ElementType = WrapWithTypeMap['defaultComponent']> = OverrideProps<
  WrapWithTypeMap<{}, D>,
  D
> & {
  component?: D;
};

export const ListEmptyFallback = <D extends ElementType = WrapWithTypeMap['defaultComponent']>({
  component,
  items,
  renderItem,
  fallback,
  children,
  ...other
}: WrapWithProps<D>) => {
  let childrenCount = 0;

  Children.forEach(children, (child) => {
    if (child) {
      childrenCount += 1;
    }
  });

  if (childrenCount) {
    const Root = component || 'div';
    return <Root {...other}>{children}</Root>;
  }
  return <>{fallback || NULLISH_VALUE}</>;
};
